import moment from 'moment'

export const getIsToday = (seconds: number) => {
  const momentRef = moment.unix(seconds)
  const today = moment().startOf('day')

  return momentRef.isSame(today, 'd')
}
